<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const modelValue = defineModel("modelValue");

withDefaults(defineProps<{
    default?: any;
    size?: "lg" | "md" | "sm";
    options: { label: string; icon?: any; value: any }[];
}>(), {
    size: "lg",
});
</script>

<template>
    <UButtonGroup :size="size" class="grid" :class="{
        'grid-cols-1': options.length === 1,
        'grid-cols-2': options.length === 2,
        'grid-cols-3': options.length === 3,
        'grid-cols-4': options.length === 4,
        'grid-cols-5': options.length === 5,
        'grid-cols-6': options.length === 6,
        'grid-cols-7': options.length === 7,
        'grid-cols-8': options.length === 8,
        'grid-cols-9': options.length === 9,
        'grid-cols-10': options.length === 10,
    }">
        <UButton v-for="option in options" :key="option.value" :color="option.value === modelValue ||
                (!modelValue &&
                    $props.default &&
                    $props.default === option.value)
                ? 'gray'
                : 'white'
            " class="justify-center active:scale-100" @click="modelValue = option.value">
            <FontAwesomeIcon v-if="option.icon" :icon="option.icon" size="lg" />
            <template v-else>{{ option.label }}</template>
        </UButton>
    </UButtonGroup>
</template>
